export default "__VITE_ASSET__bbmGAvZ8__"